import { ArrowDropDown } from '@mui/icons-material';
import {
  Accordion,
  AccordionSummary,
  Stack,
  Typography,
  AccordionDetails,
  MenuItem,
  SxProps,
  Theme,
} from '@mui/material';
import React from 'react';
import { CustomerSettings, LanguageType, MenuItemType, StyleObj } from '../../@types';
import useLocalization from '../../hooks/useLocalization';
import { mergeSx } from '../../utils/styles';

const styles: StyleObj = {
  accordion: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&:before': { display: 'none' },
  },
  accordionDetails: { flexDirection: 'column', p: 0 },
  menuItem: {
    backgroundColor: 'neutral.50',
    borderBottom: '1px solid',
    borderColor: 'neutral.100',
    minHeight: 40,
    '&:hover': { backgroundColor: 'neutral.200' },
  },
  childMenuItem: {
    backgroundColor: 'neutral.100',
    '&:hover': { backgroundColor: 'neutral.200' },
    flex: 1,
    '&.MuiMenuItem-root': {
      minHeight: 40,
      '&:not(:last-child)': {
        borderBottom: '1px solid',
        borderColor: 'neutral.200',
      },
    },
  },
};

const AccountAccordionItem = ({
  userData,
  menuItems,
  passedKeyValue,
  action,
  handleMenuItemClick,
  menuItemSx,
}: {
  userData: CustomerSettings;
  menuItems: MenuItemType[];
  passedKeyValue: string;
  action: (value?: LanguageType) => Promise<void>;
  handleMenuItemClick?: () => void;
  menuItemSx?: SxProps<Theme>;
}) => {
  const { t } = useLocalization();
  return (
    <Accordion disableGutters key={passedKeyValue} onClick={handleMenuItemClick} sx={styles.accordion}>
      <AccordionSummary
        expandIcon={menuItems?.length && <ArrowDropDown fontSize='small' />}
        sx={mergeSx(styles.menuItem, menuItemSx)}
      >
        <Stack direction='column'>
          <Typography variant='body3'>{t('selectLanguage')}</Typography>
          <Typography
            variant='body2'
            sx={{
              fontWeight: 600,
              flex: 1,
            }}
          >
            {menuItems?.find((item) => item.key === userData[passedKeyValue as keyof typeof userData])?.label}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={styles.accordionDetails}>
        {menuItems?.map(({ label, key }) => (
          <MenuItem
            key={label}
            onClick={async () => action(key as LanguageType)}
            disableRipple
            sx={styles.childMenuItem}
          >
            <Typography
              variant='body2'
              sx={{
                fontWeight: 600,
                flex: 1,
              }}
            >
              {label}
            </Typography>
          </MenuItem>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccountAccordionItem;
